import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { StatusChip } from "@/components/Badges";

export default function MissingEtas() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [etas, setEtas] = useState({});

  const load = () => api.get("/pos", { params: { status: "Draft - ETA Missing" } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const totalLines = items.reduce((a, p) => a + (p.line_item_count || 0), 0);

  const saveEta = async (id) => {
    if (!etas[id]) return;
    await api.patch(`/pos/${id}`, { eta: new Date(etas[id]).toISOString() });
    load();
  };

  return (
    <div>
      <div className="eyebrow">{t("nav_missing_etas")}</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>{t("fix_missing_etas")}</h1>
      <div className="text-sm text-[#4A627A] mt-1" data-testid="missing-total">
        {items.length} POs · <b>{totalLines}</b> line items awaiting ETA
      </div>

      <div className="overflow-x-auto hag-scroll mt-4">
        <table className="w-full text-sm hag-surface">
          <thead className="bg-[#FAF6F0] text-[#4A627A] uppercase text-xs tracking-widest">
            <tr>
              <th className="text-left p-3">{t("po_number")}</th>
              <th className="text-left p-3">{t("weaver_name")}</th>
              <th className="text-left p-3">Lines</th>
              <th className="text-left p-3">Status</th>
              <th className="text-left p-3">{t("eta")}</th>
              <th className="text-left p-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} data-testid={`missing-row-${p.po_number}`} className="border-t border-[#1B3A5C]/5">
                <td className="p-3 font-semibold">{p.po_number}</td>
                <td className="p-3">{p.weaver_name}</td>
                <td className="p-3">{p.line_item_count}</td>
                <td className="p-3"><StatusChip status={p.status} /></td>
                <td className="p-3">
                  <input
                    type="date"
                    data-testid={`eta-input-${p.po_number}`}
                    value={etas[p.id] || ""}
                    onChange={(e) => setEtas({ ...etas, [p.id]: e.target.value })}
                    className="h-10 border border-[#1B3A5C]/15 rounded-md px-2"
                  />
                </td>
                <td className="p-3">
                  <button data-testid={`save-eta-${p.po_number}`} onClick={() => saveEta(p.id)} className="h-10 px-3 rounded-md text-sm text-white" style={{ background: "var(--brand-navy)" }}>
                    {t("save")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
